/** Append copyright notice when copying long text from posts */
export function initCopyCopyright(): void {
  const postContent = document.querySelector('.post-content')
  if (!postContent) return

  postContent.addEventListener('copy', (e) => {
    const selection = window.getSelection()
    if (!selection || selection.toString().length < 30) return

    const clipboardData = (e as ClipboardEvent).clipboardData
    if (!clipboardData) return

    const text =
      selection.toString() +
      '\n\n\u8457\u4f5c\u6743\u5f52\u4f5c\u8005\u6240\u6709\u3002\n\u5546\u4e1a\u8f6c\u8f7d\u8bf7\u8054\u7cfb\u4f5c\u8005\u83b7\u5f97\u6388\u6743\uff0c\u975e\u5546\u4e1a\u8f6c\u8f7d\u8bf7\u6ce8\u660e\u51fa\u5904\u3002\n\u539f\u6587: ' +
      location.href

    clipboardData.setData('text/plain', text)
    e.preventDefault()
  })
}
